var PUBLIC_URL = "http://localhost:3000/"
var BASE_URL = '';

if (window.location.host.indexOf("localhost") !== -1) {
  PUBLIC_URL = "http://localhost:3000/";
  BASE_URL = 'http://localhost:5129/';
} else if (window.location.host.indexOf("dev.fe.doe.gov") !== -1 || window.location.host.indexOf("dev.hgeo.doe.gov") !== -1) {
  PUBLIC_URL = "https://dev.hgeo.doe.gov/fergas-fe/"
  BASE_URL = 'https://dev.hgeo.doe.gov/fergas-api/';
} else if (window.location.host.indexOf(".energy.gov") !== -1) {
  PUBLIC_URL = "https://hgeo.energy.gov/fergas-fe/"
  BASE_URL = 'https://hgeo.energy.gov/fergas-api/';
}

var LINK = {
  BASE_CERTIFY: BASE_URL + 'certify',
  BASE_LOGIN: BASE_URL + 'login',
  BASE_LOGOUT: BASE_URL + 'logout',
  BASE_UTILITY: BASE_URL + 'utility',

  PUBLIC_LOGIN: PUBLIC_URL + '#/login',
  PUBLIC_NOTICE: PUBLIC_URL + '#/notice',
  PUBLIC_HOME: PUBLIC_URL + 'main.html',
  PUBLIC_URL: PUBLIC_URL,

  /* Users */
  SEARCH_SOCIAL_DOMAIN: BASE_URL + 'ws/users/searchSocialDomain',
  REGISTER: BASE_URL + 'ws/users/register', // done
  // GET_COMPANY_ROLES: BASE_URL + 'ws/users/getCompanyRoles', // not required
  GET_COMPANIES_FOR_TOKEN: BASE_URL + 'ws/users/getCompanyInfosByContact', // done
  GET_ASSOCIATIONS: BASE_URL + 'ws/users/getAssociations', // done
  DELETE_ASSOCIATIONS: BASE_URL + 'ws/users/deleteAssociation', // done
  CHANGE_COMPANY_CONTACT_STATUS: BASE_URL + 'ws/users/changeCompanyContactStatus', // done
  GET_USERS_FOR_CONTACT: BASE_URL + 'ws/users/getUsersForCompany', // done
  GET_APPL_COMPANY_CONTACTS: BASE_URL + 'ws/users/getApplicationCompanyContacts', // done
  SAVE_CONTACT: BASE_URL + 'ws/users/saveContact', // done
  SEARCH_CONTACTS: BASE_URL + 'ws/users/searchContacts', // done
  DELETE_COMPANY_CONTACT: BASE_URL + 'ws/users/deleteCompanyContact', // done
  GET_MY_PROFILE: BASE_URL + 'ws/users/getMyProfile', // done
  SAVE_MY_PROFILE: BASE_URL + 'ws/users/saveMyProfile', // done
  SEND_CONTACT_US: BASE_URL + 'ws/users/sendContactUs', // done
  GET_CONTACT_DETAIL: BASE_URL + 'ws/users/getContactDetail', // done
  SAVE_CONTACT_DETAIL: BASE_URL + 'ws/users/saveContactDetail', // done

  /* Companies */
  SEARCH_COMPANIES: BASE_URL + 'ws/companies/searchCompanies',  // done
  GET_COMPANY_BY_ID: BASE_URL + 'ws/companies/getCompanyInfoByCompanyId', // not required
  GET_ALL_COMPANIES: BASE_URL + 'ws/companies/getAllCompanies', // done
  GET_LOGIN_COMPANY_DETAIL: BASE_URL + 'ws/companies/getLoginCompanyDetail', // done
  SAVE_COMPANY_DETAIL: BASE_URL + 'ws/companies/saveCompanyDetail',

  /* Applications */
  GET_APPLS_FOR_CONTACT: BASE_URL + 'ws/appls/getApplicationsForContact', // done
  GET_APPL_DOCS: BASE_URL + 'ws/appls/getApplicationDocuments', // done
  SAVE_APPL_DOC: BASE_URL + 'ws/appls/saveApplicationDocument',  // done
  SAVE_APPL: BASE_URL + 'ws/appls/saveApplication',  // done
  SUBMIT_EFILE: BASE_URL + 'ws/appls/submitEFile', // done
  GET_APPL_DETAIL: BASE_URL + 'ws/appls/getApplicationDetail', // done
  SUBMIT_APPL_REQUEST: BASE_URL + 'ws/appls/submitApplicationRequest', // done

  /* Dockets */
  GET_AUTHS_FOR_CONTACT: BASE_URL + 'ws/dockets/getAuthorizationsForContact', // done
  GET_DOCKETS_FOR_COMPANY: BASE_URL + 'ws/dockets/getDocketsByCompanyId', // done
  GET_AUTHORITIES_BY_DOCKET_ID: BASE_URL + 'ws/dockets/getAuthoritiesByDocketId', // done
  GET_REGISTRANTS_BY_DOCKET_ID: BASE_URL + 'ws/dockets/getRegistrantsByDocketId', // done
  SAVE_REGISTRANT: BASE_URL + 'ws/dockets/saveRegistrant',  // done
  DELETE_REGISTRANT: BASE_URL + 'ws/dockets/deleteRegistrant', // done
  GET_DOCKET_ORDER_LIST: BASE_URL + 'ws/dockets/getDocketOrderList', // done
  GET_DOCKET_WITH_CONTACTS: BASE_URL + 'ws/dockets/getDocketWithContacts', // done

  /* Transactions */
  GET_TRANSS_FOR_CONTACT: BASE_URL + 'ws/trans/getTransactionsForContact',
  //  GET_TEMP_TRANSS_FOR_COMPANY: BASE_URL + 'ws/trans/getTempTransactionsForCompany',
  //  SAVE_TRANS: BASE_URL + 'ws/trans/saveTrans',
  //  GET_TRANS_BY_ID: BASE_URL + 'ws/trans/getTransactionById',
  //  DELETE_TRANS: BASE_URL + 'ws/trans/deleteTransaction',

  SAVE_TEMP_MONTHLY_REPORT: BASE_URL + 'ws/trans/saveTempMonthlyReport', // done
  GET_TEMP_TRANSACTIONS: BASE_URL + 'ws/trans/getTempTransactions', // done
  GET_TRANS_COUNT: BASE_URL + 'ws/trans/getTransactionsCount',  // done - not tested
  SEARCH_TRANS: BASE_URL + 'ws/trans/searchTransactions', // done - not tested
  SUBMIT_MONTHLY_REPORT: BASE_URL + 'ws/trans/submitMonthlyReport', // done
  GET_REPORT_STAGE: BASE_URL + 'ws/trans/getReportStage',  // done
  GET_SUBMITTED_TRANSACTIONS: BASE_URL + 'ws/trans/getSubmittedTransactions', // done
  GET_LAST_TRANSACTIONS: BASE_URL + 'ws/trans/getLastTransactionsForDocket', // done
  GET_MONTHLY_REPORTS_FOR_COMPANY: BASE_URL + 'ws/trans/getMonthlyReportsForCompany', // done
  GET_SUBMITTED_REPORT_FOR_VIEW: BASE_URL + 'ws/trans/getSubmittedReportForView', // done
  SEND_SEMI_ANNUAL_REPORT: BASE_URL + 'ws/trans/sendSemiAnnualReport', // done 
  DOWNLOAD_REPORT: BASE_URL + 'ws/trans/downloadReport', // done 
  GET_RULES_WITH_HISTORY: BASE_URL + 'ws/trans/getRulesWithHistory', // done

  /* Utilities */
  GET_COUNTRIES_WITH_POEES: BASE_URL + 'ws/utility/getCountriesWithPoees', // done
  GET_COUNTRIES: BASE_URL + 'ws/utility/getCountries', // done
  GET_STATES: BASE_URL + 'ws/utility/getStates', // done
  GET_US_STATES: BASE_URL + 'ws/utility/getUsStates', // done
  GET_POEES: BASE_URL + 'ws/utility/getPoees', // done
  /*GET_POEES_BY_COUNTRY_ID: BASE_URL + 'ws/utility/getPoeesByCountryId',*/
  GET_TRANS_SYSS: BASE_URL + 'ws/utility/getTransportSystems', // done
  //  GET_TRANS_SYSS_BY_POEE_ID: BASE_URL + 'ws/utility/getTransportSystemsByPoeeId',
  GET_REGION_DETAILS: BASE_URL + 'ws/utility/getRegionDetails', // done
  GET_TANKERS: BASE_URL + 'ws/utility/getTankers', // done
  GET_TRUCKS: BASE_URL + 'ws/utility/getTrucks', // done
  GET_FACILITIES: BASE_URL + 'ws/utility/getFacilities', // done
  GET_TYPE_VALUES_BY_GROUP: BASE_URL + 'ws/utility/getTypeValuesByGroup', // done
  SEND_VERIFICATION_CODE: BASE_URL + 'ws/utility/sendVerificationCode', // done
  VERIFY_CODE: BASE_URL + 'ws/utility/verifyCode', // done
  IS_VALID_IP: BASE_URL + 'ws/utility/isValidIP', // done
  GET_SYSTEM_NOTICE: BASE_URL + 'ws/utility/GetSystemNotice', // done
  TEST_ERROR_HANDLING: BASE_URL + 'ws/utility/testErrorSystem', // done
}

module.exports = LINK;
